import { createRouter, createWebHistory } from "vue-router";
import LandingPage from "@/views/LandingPage";
import OnWifiUser from "@/views/OnWifiUser";
import ErrorPage from "@/views/ErrorPage";
import PostOptIn from "@/views/PostOptIn";
import store from "../store/index";
import ConfirmPage from "@/views/ConfirmPage";
const routes = [
    {
        path: '/',
        redirect: '/landing-page'
    },
    {
        path: '/landing-page',
        name: 'LandingPage',
        component: LandingPage,
    },
    {
        path: '/wifi',
        name: 'OnWifiUser',
        component: OnWifiUser,
        meta: { hideWinDailyBanner: true },
    },
    {
        path: '/post-opt-in',
        name: 'PostOptIn',
        component: PostOptIn,
    },
    {
        path: '/confirm-page',
        name: 'ConfirmPage',
        component: ConfirmPage,
    },
    {
        path: '/error-page',
        name: 'ErrorPage',
        component: ErrorPage,
    },
    {
        path: '/:pathMatch(.*)*',
        name: 'NotFound',
        redirect: '/landing-page'
    }
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
});

router.beforeEach(() => {
  if (!store.state.acquisitionConfig) {
      const urlParams = new URLSearchParams(window.location.search);
      const campaignId = urlParams.get('campaignId') || 0;
      const acquisitionChannel = urlParams.get('acquisitionChannel') || 'Organic-Web';
      const revenuePartnerId = urlParams.get('revenuePartnerId') || 27;
      store.commit('setAcquisitionConfig', {campaignId, acquisitionChannel, revenuePartnerId});
  }
})

export default router;
